import { refreshTokenClient } from '../api/refreshTokenClient'

// RefreshToken

type RefreshTokenResponse = {
  access: string
  refresh: string
}

export const refreshTokenRequest = async () => {
  const { access, refresh } = await refreshTokenClient.post<
    RefreshTokenResponse,
    RefreshTokenResponse
  >('/refresh-token')
  return { newAccessToken: access, newRefreshToken: refresh }
}
